export enum PresenceMonitorDashboardDataType {
  All = -100, // just for filter
  ThisWeek = 0,
  LastWeek = 1,
}
